module.exports = __webpack_public_path__ + "static/media/howls-loc.e61929e0.JPG";